import { useContext, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { ApplicationContext } from 'context'

import Layout from 'components/Layout'
import LayoutContainer from "components/LayoutContainer"

import AgentDashboard from 'components/Dashboard'

const Dashboard = () => {
  const { contextLoading, contextError, contextAgency, useCurrentPath } = useContext(ApplicationContext)
  const [isLoading, setIsLoading] = contextLoading // eslint-disable-line
  const [_, setError] = contextError // eslint-disable-line
  const [agency] = contextAgency // eslint-disable-line
  const [tab, setTab] = useState('DASHBOARD')
  
  const navigate = useNavigate()
  const currentPath = useCurrentPath()

  useEffect(() => {
    if (agency && agency?.isAgentOnboarding && currentPath.indexOf('onboarding') < 0) {
      navigate(`/onboarding`)
    }
  }, [navigate, agency, currentPath])

  useEffect(()=> {
    if(currentPath === '/dashboard'){
      setTab('DASHBOARD')
    }
  }, [currentPath])

  let content = null
  if (agency) {
    let title = `Welcome back ${agency.employee.nameFirst}!`
    let description = "Build out your dashboard with widgets...coming soon!"
    content = (
      <LayoutContainer title={title} description={description}>
        {tab === 'DASHBOARD' && <AgentDashboard />}
      </LayoutContainer>
    )
  }

  return (
    <Layout>
      {content}
    </Layout>
  )
}

export default Dashboard
